export default __webpack_public_path__ + "static/media/patternbg.11d7dbb7.png";